import React, { useContext } from "react";
import {
  UserOutlined,
  TeamOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import { Card, Col, Row, Statistic, Avatar } from "antd";
import AppContext from "../../../../../config/AppContext";

export default function CaregiverDetails() {
  const { loginUserDetails } = useContext(AppContext);

  return (
    <div>
      <Row gutter={[32, 32]}>
        <Col span={12} offset={6}>
          <div style={{ marginTop: "20%" }}>
            <Row justify={"center"}>
              {loginUserDetails?.securedFileUrl ? (
                <Avatar
                  size={120}
                  style={{
                    border: "3px solid #a5a5a5",
                    backgroundColor: "#d5d5d5",
                  }}
                  src={loginUserDetails?.securedFileUrl}
                />
              ) : loginUserDetails?.firstName ? (
                <Avatar
                  size={120}
                  style={{ background: "#6a347d", border: "5px solid grey" }}
                >
                  <span style={{ fontSize: "50px" }}>
                    {loginUserDetails?.firstName?.charAt(0).toUpperCase()}
                  </span>
                </Avatar>
              ) : (
                <Avatar
                  size={120}
                  style={{ background: "#6a347d" }}
                  icon={<UserOutlined />}
                ></Avatar>
              )}
            </Row>

            <div
              style={{
                textAlign: "center",
                fontSize: "48px",
                margin: "10px",
              }}
            >
              <span>Hello {loginUserDetails?.firstName},</span>
            </div>
            <div
              style={{
                color: "grey",
                textAlign: "center",
                fontSize: "40px",
                marginBottom: "20px",
              }}
            >
              <span>Welcome to the VIF Portal</span>
            </div>
          </div>
        </Col>
      </Row>

      <Row gutter={[16, 16]} justify="center">
        <Col
          xxl={{ span: 6 }}
          xl={{ span: 6 }}
          lg={{ span: 6 }}
          md={{ span: 24 }}
          sm={{ span: 24 }}
          xs={{ span: 24 }}
        >
          <Card className="card-container" bordered={false}>
            <Statistic
              title="Caregiver Profiles"
              value={loginUserDetails?.profileCount?.C || 0}
              valueStyle={{
                color: "#6a347d",
              }}
              prefix={<TeamOutlined />}
            />
          </Card>
        </Col>
        <Col
          xxl={{ span: 6 }}
          xl={{ span: 6 }}
          lg={{ span: 6 }}
          md={{ span: 24 }}
          sm={{ span: 24 }}
          xs={{ span: 24 }}
        >
          <Card className="card-container" bordered={false}>
            <Statistic
              title="Support Network Profiles"
              value={loginUserDetails?.profileCount?.SN || 0}
              valueStyle={{
                color: "#3f8600",
              }}
              prefix={<UserSwitchOutlined />}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
